import React from "react";

import { MPLogoWhite } from "../../../assets";
import EnvironmentSwitcher from "../../common/EnvironmentSwitcher";
import { ENV_SWITCHER_ENABLED } from "../../../environments";

const HomeHeader: React.FC = () => {
  return (
    <header className="flex-between p-4">
      <img src={MPLogoWhite} className="w-20" />
      {ENV_SWITCHER_ENABLED && <EnvironmentSwitcher />}
    </header>
  );
};

export default HomeHeader;
